import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { ReadingsState } from '@/models/states/readings-state.model';

export const actions: ActionTree<ReadingsState, RootState> = {};
